import React from 'react';

interface Row {
  scenario: string;
  market: string | null;
  vol_shock: string | null;
  est_pnl: string | null;
  est_pnl_num: number | null;
}

interface Props {
  rows: Row[];
  scenarioNarrative?: string;
}

const ScenarioTable: React.FC<Props> = ({ rows, scenarioNarrative }) => {
  if (!rows || rows.length === 0) return null;

  const pnlClass = (n: number | null) => {
    if (n == null) return '';
    if (n <= -20) return 'pnl-critical';
    if (n <= -5)  return 'pnl-warning';
    if (n >= 5)   return 'pnl-good';
    return '';
  };

  const prettyScenario = (s: string) => s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

  return (
    <section className="scenario-table-section">
      <h3>Scenario P&amp;L</h3>
      <div className="scenario-table-wrap">
        <table className="scenario-table">
          <thead>
            <tr>
              <th>Scenario</th>
              <th className="num">Market</th>
              <th className="num">Vol shock</th>
              <th className="num">Est. P&amp;L</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{prettyScenario(r.scenario)}</td>
                <td className="num">{r.market ?? '—'}</td>
                <td className="num">{r.vol_shock ?? '—'}</td>
                <td className={`num bold ${pnlClass(r.est_pnl_num)}`}>{r.est_pnl ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {scenarioNarrative && (
        <p className="scenario-narrative">{scenarioNarrative}</p>
      )}
    </section>
  );
};

export default ScenarioTable;
